import React from 'react';

export default function HeatExchanger4Icon({
  width = 64,
  height = 85,
  startColor = '#BF0000',
  midColor = '#FFE5E5',
  endColor = '#BF0000'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 84.348 112.5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_Heat_Exchanger">
	<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="4.6174" y1="56.25" x2="28.0413" y2="56.25">
		<stop offset="0" style={{stopColor: "#FF0000"}} />
		<stop offset="1" style={{stopColor: "#DC0000"}} />
	</linearGradient>
	<path fill={`url(#${id}_1_)`} d="M4.617,112.5V28.041L28.041,0v84.347L4.617,112.5z" />
	<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="18.6946" y1="56.25" x2="42.1174" y2="56.25">
		<stop offset="0" style={{stopColor: "#FF0000"}} />
		<stop offset="1" style={{stopColor: "#BF0000"}} />
	</linearGradient>
	<path fill={`url(#${id}_2_)`} d="M18.695,112.5V28.041L42.117,0v84.347L18.695,112.5z" />
	<linearGradient id={`${id}_3_`} gradientUnits="userSpaceOnUse" x1="32.7708" y1="56.25" x2="56.1946" y2="56.25">
		<stop offset="0" style={{stopColor: "#FF0000"}} />
		<stop offset="1" style={{stopColor: "#BF0000"}} />
	</linearGradient>
	<path fill={`url(#${id}_3_)`} d="M32.771,112.5V28.041L56.195,0v84.347L32.771,112.5z" />
	<linearGradient id={`${id}_4_`} gradientUnits="userSpaceOnUse" x1="46.8479" y1="56.25" x2="70.2708" y2="56.25">
		<stop offset="0" style={{stopColor: "#FF0000"}} />
		<stop offset="1" style={{stopColor: "#BF0000"}} />
	</linearGradient>
	<path fill={`url(#${id}_4_)`} d="M46.848,112.5V28.041L70.271,0v84.347L46.848,112.5z" />
	<linearGradient id={`${id}_5_`} gradientUnits="userSpaceOnUse" x1="60.9241" y1="56.25" x2="84.3479" y2="56.25">
		<stop offset="0" style={{stopColor: "#FF0000"}} />
		<stop offset="1" style={{stopColor: "#DC0000"}} />
	</linearGradient>
	<path fill={`url(#${id}_5_)`} d="M60.924,112.5V28.041L84.348,0v84.347L60.924,112.5z" />
</g>
<g id="Group_Top_Cover">
	<path fill="#FFE5E5" stroke="#FF0000" strokeWidth="0.1" d="M0,28.041h4.617L28.041,0h-4.617L0,28.041z" />
	<path fill="#FFE5E5" stroke="#FF0000" strokeWidth="0.1" d="M13.964,28.041h4.73L42.117,0H37.5L13.964,28.041z" />
	<path fill="#FFE5E5" stroke="#FF0000" strokeWidth="0.1" d="M28.041,28.041h4.729L56.195,0h-4.73L28.041,28.041z" />
	<path fill="#FFE5E5" stroke="#FF0000" strokeWidth="0.1" d="M42.117,28.041h4.73L70.271,0h-4.729L42.117,28.041z" />
	<path fill="#FFE5E5" stroke="#FF0000" strokeWidth="0.1" d="M56.195,28.041h4.729L84.348,0h-4.73L56.195,28.041z" />
</g>
<g id="Group_Front_Rods">
	<path fill="#BF0000" d="M0,28.041h4.617V112.5H0V28.041z" />
	<path fill="#BF0000" d="M13.964,28.041h4.73V112.5h-4.73V28.041z" />
	<path fill="#BF0000" d="M28.041,28.041h4.729V112.5h-4.729V28.041z" />
	<path fill="#BF0000" d="M42.117,28.041h4.73V112.5h-4.73V28.041z" />
	<path fill="#BF0000" d="M56.195,28.041h4.729V112.5h-4.729V28.041z" />
</g>
    
      </g>
      <rect x="0" y="0" width="84.348" height="112.5" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
